export type RegistrationFlow =
  | 'edu'
  | 'upsale'
  | 'appLanding'

export const EDU: RegistrationFlow = 'edu';
export const UPSALE: RegistrationFlow = 'upsale';
export const APP_LANDING: RegistrationFlow = 'appLanding';
